import React from 'react';
import { styled } from 'styled-components';
import { MEDIA_WIDTHS } from '../theme/Theme';
import { Image } from 'antd';

const Wrapper = styled.div`
    width: 100%;
    .body {
        margin: 0 auto;
        margin-top: 30px;
        padding: 40px 20px;
        width: 100%;
        max-width: 1440px;
        display: flex;
        flex-direction: row;
        .large-primary {
            font-family: 'Joystix';
            font-style: normal;
            font-weight: 400;
            font-size: 32px;
            line-height: 34px;
            color: #ea34b0;
            text-decoration: none;
            text-align: center;
            margin-bottom: 10px;
        }
        .content-top {
            flex: 1;
            .large-title {
                font-family: 'Karmatic Arcade';
                font-style: normal;
                font-weight: 400;
                font-size: 40px;
                line-height: 56px;
                text-align: center;
                letter-spacing: 2px;
                color: #000000;
                max-width: 963px;
                margin: auto;
            }
            .small-title {
                font-family: 'Joystix';
                font-style: normal;
                font-weight: 400;
                font-size: 22px;
                line-height: 34px;
                color: #585858;
                max-width: 814px;
                text-align: center;
                color: #585858;
                margin: auto;
                margin-top: 40px;
            }
        }
        .right {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .content-top {
            margin: auto;
            display: block;
        }
    }

    @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
        .body {
            flex-direction: column;
        }
        .large-title {
            font-size: 32px !important;
        }
        .small-title {
            margin-top: 50px !important;
            font-size: 22px !important;
        }
    }
`;

const TopBanner = () => {
    return (
        <Wrapper>
            <div className="body">
                <div className="content-top">
                    <p className="large-primary">BPunks</p>
                    <p className="large-title"> Unleashing the Power of Trustless Computer on Bitcoin</p>
                    <p className="small-title">
                        Each of these 10,000 BPunks has attributes that make them unique according to a defined rarity
                        system.
                    </p>
                </div>
            </div>
        </Wrapper>
    );
};

export default TopBanner;
